import {
  PAYWAY_TRANSACTIONS_FETCH_REQUESTED,
  PAYWAY_TRANSACTIONS_FETCHED,
} from 'utils/constants'
import { reduce } from 'lodash';

export default (state = {}, action) => {
  switch (action.type) {
    case PAYWAY_TRANSACTIONS_FETCH_REQUESTED:
      return { ...state, fetching: true };
    case PAYWAY_TRANSACTIONS_FETCHED:
      const paywayTransactions = reduce(action.data.paywayTransactions, (obj, payway_transaction) => {
        obj[payway_transaction.transactionId] = payway_transaction
        return obj
      }, {});
      return { ...state, fetching: false, paywayTransactions };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/payway_transactions.js